<script>
import OverviewIcon from './icons/OverviewIcon.vue';
import CompareOddsIcon from './icons/CompareOddsIcon.vue';
import FullFormIcon from './icons/FullFormIcon.vue';
export default {
  name: 'EventHeaderTabs',
  components: {
    OverviewIcon,
    CompareOddsIcon,
    FullFormIcon,
  },
  props: {
    iconType: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iconList: [
        {
          id: 'overview',
          text: this.isMobile ? 'Form' : 'Overview',
          url: '#Overview',
          showTab: true,
        },
        {
          id: 'compareOdds',
          text: 'Compare Odds',
          url: '#OddsComparison',
          showTab: !this.isMobile,
        },
        {
          id: 'fullForm',
          text: 'Full Form',
          url: '#FullForm',
          showTab: !this.isMobile,
        },
      ],
    };
  },
};
</script>

<template>
  <div :class="{ 'mobile-event-header-tabs': isMobile }" class="event-header-tabs">
    <div class="event-header-tabs__container">
      <template v-for="(icon, index) in iconList">
        <a
          v-if="icon.showTab"
          :href="`${icon.url}`"
          :data-tab-key="icon.id"
          :key="`event-header-tab-${index}`"
          class="event-header-tab"
        >
          <OverviewIcon v-if="icon.id === `overview`" />
          <CompareOddsIcon v-if="icon.id === `compareOdds`" />
          <FullFormIcon v-if="icon.id === `fullForm`" />

          <span class="event-header-tab__text">{{ icon.text }}</span>
        </a>
      </template>
    </div>
  </div>
</template>
